// extracted by mini-css-extract-plugin
export default {"root":"fowaDLy7_R1TiZj1wxoD"};